import type {
  ReviewItem,
  WorkflowReviewStatusData,
} from '@app/shared/types/sf-data'

import { defineStore } from 'pinia'

import { ref } from 'vue'

import { getReviewItemKey } from '@app/application/workflows/screens/workflow-review/utils'

export const useWorkflowReviewItemStatus = defineStore(
  'workflowReviewItemStatus',
  () => {
    const reviewItemStatus = ref<Record<string, WorkflowReviewStatusData>>({})

    function receiveItemStatuses(reviewItems: ReviewItem[]): void {
      reviewItems.forEach((reviewItem) => {
        const key = getReviewItemKey({
          itemClass: reviewItem.itemClass,
          id: reviewItem.id,
        })

        if (reviewItem.workflowReviewStatusData) {
          const { review, reviews, ...rest } =
            reviewItem.workflowReviewStatusData

          reviewItemStatus.value[key] = {
            review,
            reviews,
            ...Object.freeze(rest),
          }
        }
      })
    }

    function updateReviewItemStatus({
      parentId,
      itemClass,
      reviews,
      review,
      ...rest
    }: WorkflowReviewStatusData & {
      parentId: number
    }): void {
      const key = getReviewItemKey({
        itemClass,
        id: parentId,
      })

      const previousReviewItemStatus = reviewItemStatus.value[key]

      reviewItemStatus.value[key] = {
        ...previousReviewItemStatus,
        ...rest,
        itemClass,
        review,
        reviews,
      }
    }

    return {
      receiveItemStatuses,
      reviewItemStatus,
      updateReviewItemStatus,
    }
  }
)
